module.exports = "<option value=\"{%-key %}\">{%-value %}</option>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/fxoReceivingScreen/html/packingSkuOption.html
// module id = 1321
// module chunks = 1